/* eslint-disable no-restricted-globals */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-mixed-spaces-and-tabs */
import { DialogContent, DialogTitle } from '@mui/material';
import React, { useContext, useState } from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import FormControl from '@mui/material/FormControl';
import { LanguageContext } from '../../../../../libs/Context';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { updateFolder } from '../../../../actions/media_actions';
import { MediaContext } from '../../..';
import { setMediaKitData } from '../../../../../redux/MediakitRedux';
import { catchErr } from '../../../../../libs/HelperContent';
import Loading from '../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import useCheckExistFolder from '../../../customHooks/useCheckExistFolder';
import { useParams } from 'react-router-dom';

const RenameFolder = (props:any) =>
{
	const { renameData, from, setUpdate, handlePopup, setRenameData } = props;
	const { tab, setCreatLoading, creatLoading } = useContext(MediaContext);
	const { language } = useContext(LanguageContext);
	const mediaData = useSelector((state:any) => state?.mymediakit?.mediaKitData);
	const userData = useSelector((state:any) => state?.mysession?.session);

	let fileExtension = '';
	let updateName:any = '';

	if (renameData?.type === 1)
	{
		updateName = renameData?.name?.split('.');
		fileExtension = updateName?.length > 1 ? updateName.pop() : '';
		updateName = updateName.join('.');
	}
	else updateName = renameData?.name;

	const [ rename, setRename ] = useState<any>(updateName);

	const checkFolderName = useCheckExistFolder();
	const dispatch = useDispatch();
	const parentId = useParams()?.id || '';
	const disableBtn = rename === '' || rename === updateName;
	const visibleData:any = {
		0 : 'folderData',
		1 : 'sharedData',
		2 : 'employeeData',
		4 : 'myTemplateData'
	};

	const handleClose = () =>
	{
		handlePopup({ rename: false });
	};
	const handleUpdateName = async () =>
	{
		const query:any = {
			uid     : userData?.userId,
			comid   : userData?.companyId,
			empRole : userData?.empRole,
			role    : userData?.role,
			type    : 'rename'

		};
		const body = {
			id   : renameData?.folderId,
			name : fileExtension ? rename?.trim().concat('.', fileExtension) : rename?.trim()
		};

		if (!creatLoading)
		{
			try
			{
				const res = await updateFolder(query, body);

				if (res?.status)
				{
					const updateArr = mediaData[visibleData[tab]]?.length > 0 && mediaData[visibleData[tab]]?.map((folderD:any) =>
					{
						if (folderD?.folderId === renameData?.folderId)
						{
							return { ...folderD, ...res?.data };
						}
						else
						{
							return folderD;
						}
					});

					from === 'preview' && setUpdate(body);
					dispatch(setMediaKitData({ [visibleData[tab]]: updateArr }));

					// visibleData[tab] = updateArr;
				}
				toast.success(`${renameData?.type === 0 ? `${language?.folderNameUpdated}` : language.fileNameUpdatedSuccessfully}`, {
					position  : toast.POSITION.TOP_RIGHT,
					className : 'toast-message'
				});
				handleClose();
				setCreatLoading(false);
				from === 'preview' && setRenameData({});
			}
			catch (err)
			{
				catchErr(err);
				setCreatLoading(false);
			}
		}
	};

	const checkExist = async () =>
	{
		setCreatLoading(true);

		const check = await checkFolderName([ fileExtension ? rename?.trim().concat('.', fileExtension) : rename?.trim() ], parentId, renameData?.type, tab === 1 ? renameData?.ownerId : '');

		if (check?.data?.length === 0)
		{
			handleUpdateName();
		}
		else
		{
			setCreatLoading(false);
			toast.error(language.folderNameAlreadyExists, {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
	};

	const handleKeyDown = (e:any) =>
	{
		if (e.key === 'Enter' && !disableBtn)
		{
			e.preventDefault();
			checkExist();
		}
	};
	const handlechange = (e) =>
	{
		const newValue = e.target.value.trimStart().replace(/\s+/g, ' ');
		const sanitizedValue = newValue.replace(/[^a-zA-Z0-9@_&-\s]/g, '');

		setRename(sanitizedValue);
	};

	return (
		<>
			<Dialog open={Boolean(Object?.keys(renameData)?.length > 0)} fullWidth>
				<DialogTitle>{language?.rename}</DialogTitle>
				<DialogContent>
					{creatLoading && <Loading/>}
					<FormControl size='small' fullWidth>
						<OutlinedInput
							id='renameInput'
							onKeyDown={handleKeyDown}
							autoFocus
							onFocus={focus}
							value={rename}
							placeholder={language?.renameFolder}
							inputProps={{ maxLength: 100 }}
							onChange={(e) => handlechange(e)}
						/>
					</FormControl>
					<div className='flexRow alignCntr justifyEnd pdngTMD'>
						<Button
							variant='text'
							color='primary'
							disableElevation
							tabIndex={0}
							onKeyUp={(e) => { e.key === 'Enter' && handleClose(); }}
							disableRipple
							onClick={handleClose}
						>
							{language?.cancel}
						</Button>
						<Button
							id='renameButton'
							variant='contained'
							className='whiteTxt'
							tabIndex={0}
							onKeyUp={(e) => { e.key === 'Enter' && checkExist(); }}
							color='primary'
							disableElevation
							disableRipple
							disabled={disableBtn}
							onClick={checkExist}
						>
							{language?.rename}
						</Button>
					</div>
				</DialogContent>
			</Dialog>
		</>
	);
};

export default RenameFolder;